import Component from '@cell/cell-core/component/component';

import './menu-drawer.scss';

class MenuDrawer extends Component {
  constructor() {
    super();

    this.elements = {
      scrollInfo: this.querySelector('.ScrollInfo'),
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleContentScroll = this.handleContentScroll.bind(this);
  }

  componentDidMount() {
    this.on('c-drawer.close', this.handleClose);

    const checkScrollability = (navigationElement) => {
      // Content element is not (nor not enough) scrollable so there is no need to display a scroll info.
      if (navigationElement.clientHeight >= navigationElement.scrollHeight) {
        return;
      }

      // Use `addEventListener` instead of `on` to we can remove the listener later on.
      // TODO: This should work with `on` as well in the future.
      navigationElement.addEventListener('scroll', this.handleContentScroll);

      setTimeout(() => {
        this.elements.scrollInfo?.show();
      }, 500);
    };

    globalThis.on('c-button.click.open-menu', () => {
      const topNavigationElement = this.querySelector('c-navigation[data-level="1"]');

      checkScrollability(topNavigationElement);
    });

    this.querySelectorAll('summary').forEach((summaryElement) => {
      summaryElement.addEventListener('click', () => {
        this.elements.scrollInfo.hide();

        const parentNavigationElement = summaryElement.closest('c-navigation');

        parentNavigationElement.style.overflowY = 'hidden';

        // Wait for the navigation to be expanded after the click on the summary element.
        setTimeout(() => {
          checkScrollability(summaryElement.nextElementSibling);
        }, 100);
      });
    });

    this.querySelectorAll('c-button[data-action="back"]').forEach((backButtonElement) => {
      backButtonElement.addEventListener('click', () => {
        backButtonElement
          .closest('c-navigation')
          .parentNode.closest('c-navigation').style.overflowY = '';
      });
    });
  }

  handleClose() {
    // Reset open sub navigations after the drawer has been closed.
    this.querySelectorAll('details[open]').forEach((element) => {
      element.removeAttribute('open');
    });

    this.querySelectorAll('c-navigation').forEach((element) => {
      element.style.overflowY = '';
    });

    this.elements.scrollInfo?.hide();
  }

  handleContentScroll() {
    this.querySelector('.Drawer__Content').removeEventListener('scroll', this.handleContentScroll);

    this.elements.scrollInfo.hide();
  }
}

customElements.define('menu-drawer', MenuDrawer);
